import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
// import '../styles/Settings.css';

function addAlias(setter, data) {
    const primName = prompt("What is the primary (jackal) name of the new company?")
    data.aliases.push([primName, primName, "", data.currentUser[0]])
    setter(Object.assign({}, data))
}

function deleteAlias(row) {
    // console.log(row)
    const aliasDiv = document.getElementById(row[0] + "AliasDiv")
    aliasDiv.style.display = "none"

    const aliasInput = document.getElementsByName(row[1])[0]
    aliasInput.value = ""
}

function save(setter, manager) {
    const processing = document.getElementById("processing")
    const failedGPTCheck = document.getElementById("failedGPTCheck")
    processing.style.display = "flex"

    if (failedGPTCheck !== null) {
        failedGPTCheck.style.display = "none"
    }

    var settings = document.getElementsByClassName("setting")
    var newSettings = {}

    for (const setting of settings) {
        newSettings[setting.name] = setting.value
    }

    var aliases = document.getElementsByClassName("alias")
    var newAliases = {}

    for (const alias of aliases) {
        newAliases[alias.name] = alias.value
    }

    manager.request("getSettings", "POST", { "newSettings": newSettings, "newAliases": newAliases }).then(res => res.json()).then((response) => {
        processing.style.display = "none"

        const aliasDivs = document.getElementsByClassName("AliasDiv")
        for (var aliasDiv of aliasDivs) {
            aliasDiv.style.display = "flex"
        }

        setter(Object.assign({}, response))
    })
}

function Settings(args) {
    const currentAuthKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]
    const navigate = useNavigate()
    const requestManager = args.requestManager

    useEffect(() => {
        if (typeof currentAuthKey === "undefined") {
            navigate("/login")
        } else if (typeof data.keyError !== "undefined") {
            if (data.keyError === "notAuthorized") {
                navigate("/")
            } else {
                navigate("/login")
            }
        }
    })

    const [data, setData] = useState([{}])

    if (!(typeof data.status === "undefined")) {
        var settings = data.jackalSettings
        var aliases = data.aliases
        aliases.sort()
    } else {
        requestManager.request("getSettings", "POST").then(res => res.json()).then((response) => {
            setData(Object.assign({}, response))
        })
    }

    console.log(data)

    return (
        <div class="container">
            <div class="pt-5 pb-5 mb-5 text-center">
                {
                    (typeof data.status === "undefined" || typeof data.keyError !== "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (<div class="col-12">
                            {
                                (data.currentUser[1] === "Admin") ?
                                    (
                                        <>
                                            <h1 class="display-5 fw-bold">Site Settings</h1>
                                            {
                                                settings.map((row) =>
                                                    (row[0] === "blockList") ?
                                                        (<div class="form-floating mt-4">
                                                            <textarea title={row[2]} class="form-text form-control setting" id="floatingInput" autocomplete="off" name={row[0]} defaultValue={row[1].replaceAll(",", ", ")} style={{ height: "500px" }}></textarea>
                                                            <label class="form-label" for="floatingInput">{row[0]}</label>
                                                        </div>) :
                                                        (<div class="form-floating mt-4">
                                                            <input title={row[2]} type="text" class="form-text form-control setting" id="floatingInput" autocomplete="off" name={row[0]} defaultValue={row[1]}></input>
                                                            <label class="form-label" for="floatingInput">{row[0]}</label>
                                                        </div>))
                                            }
                                            <div class="pt-5"></div>
                                            {/* <h1 class="display-5 fw-bold">Aliases</h1>
                                            {aliases.map((row) =>
                                                <div class="justify-content-center text-center AliasDiv" id={row[0] + "AliasDiv"} style={{ display: "flex" }}>
                                                    <div class="input-group mt-1" style={{ width: "50%" }} key={row[2]}>
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text">{row[0]}</span>
                                                        </div>
                                                        <input type="text" class="form-control alias" autocomplete="off" name={row[1]} defaultValue={row[2]}></input>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-danger" type="button" onClick={() => deleteAlias(row)}>Delete</button>
                                                        </div>
                                                    </div>
                                                </div>)
                                            } */}

                                            {/* <button class="btn btn-outline-primary mt-3" type="button" onClick={() => addAlias(setData, data)}>+</button> */}

                                            <div class="d-flex justify-content-center mt-1">
                                                <input type="submit" method="post" onClick={() => save(setData, requestManager)} value="Save" class="btn btn-success mt-3 d-flex justify-content-center" style={{ width: "20%" }}></input>
                                            </div>
                                            <div class="justify-content-center py-1" style={{ display: "none" }} id="processing">
                                                <h1 class="loading text-secondary">Processing</h1>
                                            </div>
                                            {/* {
                                                (data.failedGPTCheck) ?
                                                    (<div class="justify-content-center py-1" id="failedGPTCheck">
                                                        <h1 class="text-danger">Sorry, one or more of the Aliases you submitted could not be verified automatically. An email has been seent to an Admin to manually approve it.</h1>
                                                    </div>) :
                                                    (<></>)
                                            } */}
                                        </>
                                    ) :
                                    (
                                        <>
                                            {/* <h1 class="display-5 fw-bold">Aliases</h1>
                                            {
                                                aliases.map((row) =>
                                                    (row[3] == data.currentUser[0]) ?
                                                    (<div class="justify-content-center text-center AliasDiv" id={row[0] + "AliasDiv"} style={{ display: "flex" }}>
                                                        <div class="input-group mt-1" style={{ width: "50%" }} key={row[2]}>
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text">{row[0]}</span>
                                                            </div>
                                                            <input type="text" class="form-control alias" autocomplete="off" name={row[1]} defaultValue={row[2]}></input>
                                                            <div class="input-group-append">
                                                                <button class="btn btn-outline-danger" type="button" onClick={() => deleteAlias(row)}>Delete</button>
                                                            </div>
                                                        </div>
                                                    </div>) :
                                                    (<></>))
                                            }

                                            <button class="btn btn-outline-primary mt-3" type="button" onClick={() => addAlias(setData, data)}>+</button> */}

                                            <div class="d-flex justify-content-center pt-2 mt-3">
                                                <input type="submit" method="post" onClick={() => save(setData, requestManager)} value="Save" class="btn btn-success mt-3 d-flex justify-content-center" style={{ width: "20%" }}></input>
                                            </div>
                                            <div class="justify-content-center py-1" style={{ display: "none" }} id="processing">
                                                <h1 class="loading text-secondary">Processing</h1>
                                            </div>
                                            {/* {
                                                (data.failedGPTCheck) ?
                                                    (<div class="justify-content-center py-1" id="failedGPTCheck">
                                                        <h1 class="text-danger">Sorry, one or more of the Aliases you submitted could not be verified automatically. An email has been seent to an Admin to manually approve it.</h1>
                                                    </div>) :
                                                    (<></>)
                                            } */}
                                        </>)
                            }
                        </div>
                        )
                }
            </div>
        </div>

    )
}

export default Settings